export const VALID_TITLE_REGEX = /[^a-zA-Z.&\s]/g;



export const VALID_URL = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/
